import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { preloadOptions } from '../Options/preloadOptions.ts';

import { getStarredQueryOptions } from './starredQueryHelpers.ts';

export const preloadStarred = ({ isLoggedIn }) => {
	return waitForAllReturnWhenError([
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query(getStarredQueryOptions({})),
		preloadOptions({ isLoggedIn }),
	]);
};
